import { Routes } from "routes";
import { State } from "store/store-types";

export function getStepperProgressPercentage(
    state: State,
    activateWebChildren: boolean,
    maxWebGuests: number,
    pathname: string
) {
    const { guests, guestsChildren, date } = state;
    const isPreorderActiveStep = pathname.includes(Routes.PREORDER);
    const isDetailsActiveStep = pathname.includes(Routes.FINALIZE);
    const allSteps = [
        { condition: guests && guests <= maxWebGuests, percentage: 35 },
        activateWebChildren
            ? {
                  condition:
                      guestsChildren !== null &&
                      guestsChildren !== undefined &&
                      guestsChildren >= 0,
                  percentage: 50,
              }
            : null,
        { condition: date, percentage: 70 },
        { condition: isPreorderActiveStep || isDetailsActiveStep, percentage: 85 },
        { condition: isDetailsActiveStep, percentage: 100 },
    ].filter(Boolean);

    return allSteps.reverse().find((step) => step?.condition)?.percentage ?? 0;
}
